// extracted by mini-css-extract-plugin
export default {"container":"home-generalInsurance_container__AAfpA","insurances":"home-generalInsurance_insurances__66JO5","insurancesFiller":"home-generalInsurance_insurancesFiller__gHKum"};